import { render, staticRenderFns } from "./wx-weapp.vue?vue&type=template&id=0a74bdd8&scoped=true&"
import script from "./wx-weapp.vue?vue&type=script&lang=js&"
export * from "./wx-weapp.vue?vue&type=script&lang=js&"
import style0 from "./wx-weapp.vue?vue&type=style&index=0&id=0a74bdd8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a74bdd8",
  null
  
)

export default component.exports